/**
 * model representing a Service Provided, i.e. by an Organization in response to a Disaster,
 * but is also used as a more generic "Service", i.e. as a Service Needed by victims of a Disaster
 */
export interface Service {
  serviceId?: number;

  name?: string;
  summary?: string;

  // due to the use of FormData API endpoint, managing the logo is quite verbose
  fileURI?: string;
  removeLogo?: boolean;
  logo?: File;

  file?: {
    fileId?: number;
    uri?: string;
  };
}
